import React from 'react'
import { Link } from 'react-router-dom'
import slider5 from '../../assets/img/slider/slider_img05.png'
import slideronebg from '../../assets/img/slider/slider_img_bg.png'

function Slider() {
  return (
    <>
        <section id="home" className="slider-area slider-four fix p-relative">
            <div className="slider-active">
                <div className="single-slider slider-bg d-flex align-items-center" style={{backgroundImage: `url(${slideronebg})`, backgroundRepeat: "no-repeat", backgroundPosition: "right top",zIndex: "0" }} >
                <div className="container">
                    <div className="row justify-content-center pt-50">
                    <div className="col-lg-7 col-md-7">
                        <div className="slider-content s-slider-content mt-150">
                        <h5 data-animation="fadeInDown" data-delay=".4s">
                            WELCOME{" "}
                        </h5>
                        <h2 data-animation="fadeInUp" data-delay=".4s">
                            We Provide Solar Energy Source
                        </h2>
                        <p data-animation="fadeInUp" data-delay=".6s">
                            Curabitur nec laoreet nulla. Mauris aliquam malesuada nibh,
                            sodales ullamp sapien imperdiet vel. Vestibulum fringilla purus
                            metus.
                        </p>
                        <div className="slider-btn mt-30">
                            <Link to="/Service" className=" mr-15 active new-btn-edit">
                              Read More
                            </Link> 
                            <Link to="/Service" className="btn ss-btn active">
                               Contact Us
                            </Link>
                        </div>
                        </div>
                    </div>
                    <div className="col-lg-5 col-md-5">
                        <div className="slider-img" data-animation="fadeInUp" data-delay=".4s" >
                            <img src={slider5} alt="slider_img05" />
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default Slider